import React from "react";
import { mdiTrayArrowUp, mdiCellphone, mdiShimmer } from "@mdi/js";
import HowItWorksModal from "../../components/common/HowItWorksModal";

const FEATURES = [
  {
    icon: mdiTrayArrowUp,
    title: "Create Template",
    description: (
      <>
        Import Spectora XLS files to create templates.
        <br />
        The system automatically extracts sections and adds narratives to your
        library.
      </>
    ),
  },
  {
    icon: mdiCellphone,
    title: "Using Templates in the Mobile App",
    description: (
      <>
        Choose a template when starting a project.
        <br />
        AI will automatically organize your notes into the right sections.
      </>
    ),
  },
  {
    icon: mdiShimmer,
    title: "AI Narrative Enhancement",
    description:
      "AI references your narrative library to generate accurate and professional results from your notes and photos.",
  },
];

const TemplatesHowItWorksModal = ({ show, onHide }) => (
  <HowItWorksModal
    show={show}
    onHide={onHide}
    title="How Smart Template Works"
    features={FEATURES}
  />
);

export default TemplatesHowItWorksModal;
